import { motion } from "framer-motion";

// Kit de componentes animados reutilizables para el landing y páginas públicas.
// Todos usan tokens de tema (hsl(var(--accent)) etc.) vía clases, así que se
// adaptan automáticamente al tema claro, oscuro y automático.

// Reveal: aparición con fade + desplazamiento al entrar en viewport.
export function Reveal({ children, delay = 0, y = 24, className = "", once = true }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, amount: 0.18 }}
      transition={{ duration: 0.55, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

// GradientText: texto con degradado cyan→success animado (pan de degradado).
export function GradientText({ children, className = "" }) {
  return <span className={`gradient-text ${className}`}>{children}</span>;
}

// AuroraBackground: blobs de gradiente suaves y animados detrás de una sección.
//pointer-events:none; colocar dentro de un contenedor relative.
export function AuroraBackground({ className = "" }) {
  return (
    <div className={`aurora-bg ${className}`} aria-hidden="true">
      <span className="aurora-blob aurora-1" />
      <span className="aurora-blob aurora-2" />
      <span className="aurora-blob aurora-3" />
    </div>
  );
}

// Marquee: tira horizontal infinita. Pausa al pasar el cursor. Duplica children.
export function Marquee({ children, className = "", speed = 40 }) {
  return (
    <div className={`marquee ${className}`}>
      <div className="marquee-track" style={{ ["--mq"]: `${speed}s` }}>
        {children}
        {children}
      </div>
    </div>
  );
}

// GlowCard: tarjeta surface con borde cyan animado y elevación al hover.
export function GlowCard({ children, className = "", ...rest }) {
  return (
    <div className={`glow-card ${className}`} {...rest}>{children}</div>
  );
}